import { useDispatch, useSelector } from 'react-redux';
import ExitButtonWrapper from '../../component/exitbutton_wrapper';
import { useLink } from 'react-router-stack';
import { useEffect, useState } from 'react';
import {
  setCurrentScore,
  setHighScore,
  setMiniGamesData,
  setMiniGamesList
} from '../../actions/mini-games-action-types';
import Modal from '@mui/material/Modal';
import GameLoader from '../../component/game_loader';
import redirectPage from '../../hoc/redirect';
import { sendMessageToIframe } from '../../utilities/helper';
import avatars from '../../constants/avatars';
import GameExitModal from '../../component/game_exit_modal';
import './index.css';
import MinigamesScoreModal from '../../component/minigames_score_modal';
import {
  myUserId,
  startLudoGame,
  teams as LudoPlayerList
} from '../../game_logic/ludo/game_service';

const Games = () => {
  const [loader, setLoader] = useState(true);
  const [isScoreCardOpen, setIsScoreCardOpen] = useState(false);
  const [isExitModalOpen, setIsExitModalOpen] = useState(false);
  const { gameDetails, miniGamesList = [] } = useSelector((state: any) => state.minigames);
  const { opponentUser: opponentUserDetail, avatarId: myUserAvatarId } = useSelector(
    (state: any) => state.user
  );

  const navigate = useLink();
  const {
    gameURL,
    gameImage = '',
    highScore = 0,
    gameType,
    currentScore = 0,
    gameName = ''
  } = gameDetails;

  const onClickYes = () => {
    setIsExitModalOpen(false);
    navigate.push('/');
  };
  const onClickNo = () => {
    setIsExitModalOpen(false);
  };
  const onPressExit = () => {
    setIsExitModalOpen(true);
  };
  const dispatch = useDispatch();

  const updateOpponentScore = (userScore: any) => {
    let opponentUser = {
      ...opponentUserDetail,
      score: userScore !== 0 && gameName !== 'Tic Tac Toe' ? userScore - 1 : 0
    };
    sendMessageToIframe({
      eventName: 'updateData',
      opponentUser
    });
  };

  const updateData = () => {
    sendMessageToIframe({
      eventName: 'updateData',
      opponentUser: { ...opponentUserDetail },
      myUser: {
        username: 'You',
        avatar: avatars[myUserAvatarId]
      }
    });
  };

  const onMessage = (e: any) => {
    const { command_type, data, eventName, score, winnerUser, eventType = '' } = e.data;
    if (gameType === 'playerVsPlayer' && gameName === 'Ludo') {
      const { players = [], roomId = '', playerId = '', tokenIndex = 0 } = e.data;
      if (eventType === 'FROM_FE_TO_GAME') {
        if (eventName === 'startGame') {
          const isMyTurn = myUserId == players[0].userId;
          const { winningsAmount = 0, winningType = 1 } = gameDetails?.contest;
          sendMessageToIframe({
            eventName: 'updateData',
            players,
            roomId,
            isMyTurn,
            poolPrize: winningType === 1 ? winningsAmount / 100 : winningsAmount,
            poolPrizeIcon: ''
          });
        } else if (eventName === 'diceThrown') {
          data.isMyTurn = isNextPlayerMe(data.nextPlayerSeatIndex);
          sendMessageToIframe({
            eventName: 'diceThrown',
            data
          });
        } else if (eventName === 'turnCompleted') {
          data.isMyTurn = isNextPlayerMe(data.nextPlayerSeatIndex);
          sendMessageToIframe({
            eventName: 'selectToken',
            data
          });
        } else if (eventName === 'gameEnd') {
          sendMessageToIframe({
            eventName: 'gameEnd',
            data
          });
          onGameEnd(data);
        }
      } else if (eventName == 'throwDisk') onDiceThrown(playerId);
      else if (eventName == 'selectToken') {
        onSelectDiceToken(playerId, tokenIndex);
      } else if (eventName == 'leaveGame') onPressExit();

      return;
    }
    if (gameType === 'playerVsPlayer') {
      if (eventName == 'gameLoaded') {
        updateData();
      }
      if (eventName === 'updateScore') {
        updateOpponentScore(score);
      }
      if (eventName === 'gameOver') {
        let myScore = 0;
        let opponentScore = 0;
        if (score !== 0 && gameName !== 'Tic Tac Toe') {
          opponentScore = score - 1;
          myScore = score;
        } else if (gameName === 'Tic Tac Toe') {
          if (winnerUser === 'draw') {
            myScore = 0;
            opponentScore = 0;
          } else if (winnerUser === 'opponent') {
            myScore = 0;
            opponentScore = 1;
          } else {
            myScore = 1;
            opponentScore = 0;
          }
        }
        navigate.push('/match_making_result', {
          myWinnerUser: { username: '', avatarId: 0, score: myScore },
          opponentWinnerUser: {
            ...opponentUserDetail,
            score: opponentScore
          }
        });
      }
    }
    if (gameType !== 'playerVsPlayer' && command_type === 'score') {
      const { score, currentScore } = data;
      if (score >= highScore) {
        let tempGame = miniGamesList.find((item: any) => item.gameName === gameDetails.gameName);
        tempGame = {
          ...tempGame,
          currentScore: gameDetails.gameName !== 'Gold Miner' ? score : currentScore,
          highScore: score
        };

        const tempGameIdx = miniGamesList.findIndex(
          (item: any) => item.gameName === gameDetails.gameName
        );
        let tempMiniGames = [...miniGamesList];
        tempMiniGames[tempGameIdx] = tempGame;
        dispatch(setMiniGamesData(tempGame));
        dispatch(setMiniGamesList(tempMiniGames));
        dispatch(setHighScore(score));
      } else {
        let tempGame = miniGamesList.find((item: any) => item.gameName === gameDetails.gameName);
        tempGame = {
          ...tempGame,
          currentScore: gameDetails.gameName !== 'Gold Miner' ? score : currentScore
        };
        dispatch(setMiniGamesData(tempGame));

        const tempGameIdx = miniGamesList.findIndex(
          (item: any) => item.gameName === gameDetails.gameName
        );
        let tempMiniGames = [...miniGamesList];
        tempMiniGames[tempGameIdx] = tempGame;
        dispatch(setMiniGamesList(tempMiniGames));
      }
      dispatch(setCurrentScore(gameDetails.gameName !== 'Gold Miner' ? score : currentScore));
      setIsScoreCardOpen(true);
      // navigate.push('/leader_board');
    }
  };
  const onClickBrowserBack = () => {
    setIsExitModalOpen(false);
    setIsScoreCardOpen(false);
  };
  useEffect(() => {
    window.addEventListener('message', onMessage_);
    window.addEventListener('popstate', onClickBrowserBack);

    return () => {
      window.removeEventListener('message', onMessage_);
      window.removeEventListener('popstate', onClickBrowserBack);
    };
  }, []);

  const onMessage_ = (event: any) => onMessage(event);

  const onLoad = () => {
    setTimeout(() => {
      setLoader(false);
    }, 1000);
  };

  const onPressScoreCardDismiss = () => {
    setIsScoreCardOpen(false);
    navigate.push('/leader_board');
  };

  const onPressPlayAgain = () => {
    setIsScoreCardOpen(false);
    sendMessageToIframe({
      type: 'DO_REVIVE',
      value: currentScore
    });
  };

  const onSelectDiceToken = (playerId: any, tokenIndex: any) => {
    const payload = {
      eventType: 'FROM_GAME_TO_FE',
      eventName: 'selectToken',
      data: {
        playerId,
        tokenIndex
      },
      gameName: gameName
    };
    sendEventToFE(payload);
  };

  const onDiceThrown = (playerId: any) => {
    const payload = {
      eventName: 'throwDice',
      eventType: 'FROM_GAME_TO_FE',
      data: {
        playerId
      },
      gameName
    };
    sendEventToFE(payload);
  };

  const onGameEnd = (data: any) => {
    const { players = [] } = data;
    const myUser = players.find((player: any) => player.userId === myUserId);
    const opponentUser = players.find((player: any) => player.userId != myUserId);

    const payload = {
      myWinnerUser: {
        ...myUser,
        userId: myUser.playerId,
        score: myUser.rank === 1 ? 1 : 0
      },
      opponentWinnerUser: {
        ...opponentUserDetail,
        ...opponentUser,
        userId: opponentUser.playerId,
        score: opponentUser.rank === 1 ? 1 : 0
      }
    };

    setTimeout(() => {
      navigate.push('/match_making_result', {
        ...payload
      });
    }, 3000);
  };

  const sendEventToFE = (payload: any) => {
    window.postMessage(payload, '*');
  };

  const isNextPlayerMe = (nextPlayerSeatIndex: any) => {
    if (nextPlayerSeatIndex > 0) {
      const nextPlayer = LudoPlayerList.find(
        (player: any) => player.seatIndex === nextPlayerSeatIndex
      );
      if (nextPlayer && nextPlayer.userId === myUserId) {
        return true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (!loader && gameName != 'Ludo') return;
    startLudoGame(opponentUserDetail);
  }, [loader]);

  return (
    <div className="gameinfo__iframe__wrapper">
      <iframe
        title={'games'}
        allowFullScreen={true}
        src={gameURL}
        id="miniGameIframe"
        name="miniGameIframe"
        className="gameIframe"
        onLoad={onLoad}
      />
      <ExitButtonWrapper onPressExit={onPressExit} />
      <Modal open={loader}>
        <GameLoader gameLogo={gameImage} />
      </Modal>
      <Modal open={isExitModalOpen}>
        <GameExitModal onClickYes={onClickYes} onClickNo={onClickNo} />
      </Modal>
      <MinigamesScoreModal
        visible={isScoreCardOpen}
        onPressDismiss={onPressScoreCardDismiss}
        lastScore={currentScore}
        highScore={highScore}
        onPressPlayAgain={onPressPlayAgain}
      />
    </div>
  );
};

export default redirectPage(Games);
